// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as React$1 from "@sentry/react";

function ErrorFallBackCmp(Props) {
  var children = Props.children;
  var error = Props.error;
  React.useEffect((function () {
          React$1.captureException(error, {
                tags: {
                  type: "VIEW_ERROR"
                }
              });
          
        }), []);
  return React.createElement(React.Fragment, undefined, children);
}

var make = ErrorFallBackCmp;

export {
  make ,
  
}
/* react Not a pure module */
